function getUserActivityState(state) {
  return {
    userActivity: state.userActivity.userActivity,
    isLoading: state.userActivity.loading,
    fetched: state.userActivity.fetched,
    fetchError: state.userActivity.fetchActivityError,
    success: state.userActivity.success,
    putError: state.userActivity.putActivityError,
    deleteError: state.userActivity.deleteActivityError,
    frequencies: state.userActivity.frequencies,
    frequenciesError: state.userActivity.fetchFrequenciesError
  };
}

function getMessageActivityState(state) {
  return state.userActivity.messageActivity;
}

export { getUserActivityState, getMessageActivityState };
